import apiClient from './axios';
import { normalizeSearchTerm } from './search';

export async function fetchMails({ offset = 0, limit = 50, search = '' } = {}) {
  // console.log(`fetchMails ${offset} to ${offset+limit}`);
  const normalizedSearch = normalizeSearchTerm(search);

  const res = await apiClient.get('/v3/mail', {
    params: { 
      offset: offset, 
      limit: limit,
      search: normalizedSearch || undefined,
    },
  });

  // console.log(`fetchMails -> ${ JSON.stringify( res, null, 2 )}`);

  return res;
}

export async function resendVerificationMail({ userUuid }) {
  const res = await apiClient.post('/v3/user/verify/resend', {
    userUuid,
  });

  return res.data;
}
